<div class="breadcrumb-container container">
  <p-breadcrumb [model]="items" [home]="home" />
</div>

<div class="checkout-layout container">
  <!-- ════════════════ COLUNA ESQUERDA: RESUMO DA CAMPANHA ════════════════ -->
  <aside class="checkout-summary">
    <div class="summary-card">
      <div class="summary-img-wrap">
        <img [src]="imgPreview || '/images/campanha-1.png'" [alt]="campanha?.titulo || 'Campanha'" />
        <div class="summary-img-badges">
          <span class="summary-badge cat" *ngIf="campanha?.categoria?.descricao">
            <i class="fa-solid fa-tag"></i> {{ campanha?.categoria?.descricao }}
          </span>
          <span class="summary-badge status">
            <i class="fa-solid fa-circle-check"></i> Em Curso
          </span>
        </div>
      </div>

      <div class="summary-body">
        <h2 class="summary-title">{{ campanha?.titulo }}</h2>

        <div class="summary-creator">
          <div class="creator-avatar">
            <i class="fa-solid fa-user-shield"></i>
          </div>
          <div class="creator-info">
            <span class="creator-label">Promotor Verificado</span>
            <strong class="creator-name">{{ campanha?.utilizadorNome || "Promotor da Campanha" }}</strong>
          </div>
        </div>

        <p class="summary-desc">
          <app-truncate-text [text]="campanha?.descricaoCurta || 'Sem descrição breve'"
            [limit]="140"></app-truncate-text>
        </p>

        <!-- Meta e Progresso -->
        <div class="summary-progress-box">
          <div class="spb-header">
            <span class="spb-title">Progresso da Angariação</span>
            <span class="spb-pct">{{ getPercent(campanha) }}%</span>
          </div>
          <div class="spb-bar">
            <div class="spb-fill" [style.width.%]="getPercent(campanha)"></div>
          </div>

          <div class="spb-metrics">
            <div class="spb-col">
              <span class="spb-label">Arrecadado</span>
              <span class="spb-val primary">{{ campanha?.valorArrecado | money }} Kz</span>
            </div>
            <div class="spb-col text-right">
              <span class="spb-label">Meta do Projecto</span>
              <span class="spb-val">{{ campanha?.metaArrecadar | money }} Kz</span>
            </div>
          </div>
          <div class="spb-remaining-row mt-2" *ngIf="getMetaCampanha() > 0">
            <span class="spb-rem-lbl"><i class="fa-solid fa-bullseye text-primary mr-1"></i> Falta para a meta:</span>
            <span class="spb-rem-val font-semibold text-gray-800">{{ getValorRestanteCampanha() | money }} Kz</span>
          </div>
        </div>

        <!-- Tags informativas -->
        <div class="summary-tags-grid">
          <div class="st-item">
            <div class="st-icon"><i class="fa-solid fa-users"></i></div>
            <div class="st-text">
              <span class="st-val">{{ campanha?.totalApoiantes || 0 }}</span>
              <span class="st-lbl">Apoiadores</span>
            </div>
          </div>

          <div class="st-item">
            <div class="st-icon"><i class="fa-regular fa-clock"></i></div>
            <div class="st-text">
              <span class="st-val">{{ campanha?.diasRestantes || 0 }}</span>
              <span class="st-lbl">Dias restantes</span>
            </div>
          </div>

          <div class="st-item">
            <div class="st-icon"><i class="fa-solid fa-location-dot"></i></div>
            <div class="st-text">
              <span class="st-val">{{ campanha?.provincia?.descricao || "Angola" }}</span>
              <span class="st-lbl">Localização</span>
            </div>
          </div>

          <div class="st-item">
            <div class="st-icon"><i class="fa-solid fa-hand-holding-heart"></i></div>
            <div class="st-text">
              <span class="st-val">{{ campanha?.tipoFinanciamento || "Doação" }}</span>
              <span class="st-lbl">Modalidade</span>
            </div>
          </div>
        </div>

        <!-- Trust badge -->
        <div class="summary-trust-badge">
          <i class="fa-solid fa-shield-halved"></i>
          <div>
            <strong>Pagamento 100% Protegido</strong>
            <span>Certificação EMIS / Rede Multicaixa com encriptação de ponta.</span>
          </div>
        </div>
      </div>
    </div>
  </aside>

  <!-- ════════════════ COLUNA DIREITA: CHECKOUT E PAGAMENTO ════════════════ -->
  <main class="checkout-main">
    <div class="checkout-card">
      <div class="checkout-card-header">
        <div class="cch-icon"><i class="fa-solid fa-hand-holding-dollar"></i></div>
        <div>
          <h1 class="cch-title">Financiar Campanha</h1>
          <p class="cch-subtitle">Defina o montante do seu apoio e escolha a forma de pagamento segura.</p>
        </div>
      </div>

      <div class="checkout-card-body">
        <!-- Aviso de autenticação para visitantes -->
        <div *ngIf="!IsAuthenticad" class="alert-auth-required mb-4" style="background: rgba(245, 158, 11, 0.08); border: 1px solid rgba(245, 158, 11, 0.3); border-radius: 12px; padding: 1rem 1.25rem; display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;">
          <div style="display: flex; align-items: center; gap: 0.75rem;">
            <i class="fas fa-user-lock" style="color: #d97706; font-size: 1.25rem;"></i>
            <span style="font-size: 0.9rem; color: #92400e; font-weight: 500;">
              Inicie sessão ou crie a sua conta para concluir o financiamento desta campanha.
            </span>
          </div>
          <div style="display: flex; gap: 0.5rem;">
            <button type="button" class="btn btn-amber btn-sm btn-rounded" (click)="irParaRegisto()">
              Criar Conta
            </button>
            <button type="button" class="btn btn-outline btn-sm btn-rounded" (click)="irParaLogin()">
              Iniciar Sessão
            </button>
          </div>
        </div>

        <!-- Opções de Modalidade de Apoio em Campanhas de Recompensa -->
        <div *ngIf="IsrecompensaCampanha && campanha?.recompensa?.length" class="apoio-modo-selector mb-6">
          <div class="ams-header">
            <span class="ams-title"><i class="fa-solid fa-sliders"></i> Como deseja apoiar este projecto?</span>
          </div>
          <div class="ams-tabs">
            <button type="button" class="ams-tab" [class.active]="!apoiarSemRecompensa" (click)="ativarModoComRecompensa()">
              <i class="fa-solid fa-gift"></i>
              <div class="ams-tab-text">
                <strong>Escolher com Recompensa</strong>
                <small>Receba as recompensas físicas ou digitais</small>
              </div>
            </button>
            <button type="button" class="ams-tab" [class.active]="apoiarSemRecompensa" (click)="escolherApoioSemRecompensa()">
              <i class="fa-solid fa-hand-holding-heart"></i>
              <div class="ams-tab-text">
                <strong>Apoio de Livre Vontade</strong>
                <small>Contribua com qualquer valor, sem recompensas</small>
              </div>
            </button>
          </div>
        </div>

        <!-- Seleção de Recompensa (Quando NÃO estiver em apoio livre) -->
        <div *ngIf="campanha?.recompensa?.length && !apoiarSemRecompensa" class="recompensas-selection mb-6">
          <h4 class="checkout-section-title">
            <i class="fa-solid fa-gift"></i> {{ IsrecompensaCampanha ? 'Seleccione a sua Recompensa' : 'Escolha uma Recompensa (Opcional)' }}
            <span class="text-red-500" *ngIf="IsrecompensaCampanha">*</span>
          </h4>
          <p class="checkout-section-desc">
            {{ IsrecompensaCampanha 
                ? 'Clique numa das opções abaixo para definir o valor do apoio com base na recompensa escolhida.' 
                : 'Seleccione uma recompensa disponibilizada pelo promotor ou apoie livremente.' }}
          </p>

          <div class="recompensas-checkout-grid">
            <div class="rc-card" *ngFor="let recompensa of campanha?.recompensa"
              (click)="selecionarRecompensa(recompensa)" [class.selected]="recompensaSelecionada?.id === recompensa.id">
              <div class="rc-check"><i class="fa-solid fa-check"></i></div>
              <div class="rc-top-row">
                <div class="rc-val">{{ recompensa?.valor | money }} Kz</div>
                <span class="rc-badge" *ngIf="recompensa?.tipoRecompensa">{{ recompensa?.tipoRecompensa }}</span>
              </div>
              <div class="rc-title">{{ recompensa?.titulo }}</div>
              <p class="rc-desc">{{ recompensa?.descricao }}</p>
              <div class="rc-meta-footer" *ngIf="recompensa?.quantidade">
                <small><i class="fa-solid fa-boxes-stacked mr-1"></i>{{ recompensa?.quantidadeDisponivel ?? recompensa?.quantidade }} disponíveis</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Formulário de Pagamento -->
        <form [formGroup]="form" class="checkout-form">
          <!-- Saldo em Carteira -->
          <div class="wallet-balance-box" *ngIf="useSaldoUser">
            <div class="wbb-icon"><i class="fa-solid fa-wallet"></i></div>
            <div class="wbb-content">
              <span class="wbb-label">Saldo Disponível em Carteira</span>
              <span class="wbb-val">{{ saldo | money }} Kz</span>
            </div>
          </div>

          <!-- Montante da Recompensa Selecionada (Exibido quando no modo com recompensa) -->
          <div class="selected-reward-amount-card mb-6" *ngIf="IsrecompensaCampanha && !apoiarSemRecompensa">
            <div class="srac-header">
              <span class="srac-label">Montante da Recompensa Seleccionada</span>
              <span class="srac-badge" *ngIf="recompensaSelecionada">
                <i class="fa-solid fa-circle-check"></i> Recompensa Definida
              </span>
            </div>

            <div class="srac-body" *ngIf="recompensaSelecionada; else noRewardSelected">
              <div class="srac-info">
                <strong class="srac-title">{{ recompensaSelecionada?.titulo }}</strong>
                <span class="srac-desc">{{ recompensaSelecionada?.descricao }}</span>
              </div>
              <div class="srac-amount">
                <span class="srac-currency">Kz</span>
                <span class="srac-val">{{ recompensaSelecionada?.valor | money }}</span>
              </div>
            </div>

            <ng-template #noRewardSelected>
              <div class="srac-empty">
                <i class="fa-solid fa-arrow-up text-amber-500 mr-2"></i>
                <span>Por favor, clique numa das opções de recompensa acima para definir o montante, ou mude para <strong>Apoio de Livre Vontade</strong>.</span>
              </div>
            </ng-template>
          </div>

          <!-- Valor do Apoio (Exibido no modo livre OU se não for campanha de recompensa) -->
          <div class="form-group mb-6" *ngIf="!IsrecompensaCampanha || apoiarSemRecompensa">
            <div class="flex items-center justify-between mb-1">
              <label class="form-label" for="valorApoio">
                Montante da Contribuição (Kz) <span class="text-red-500">*</span>
              </label>
              <span class="text-xs text-primary font-semibold" *ngIf="IsrecompensaCampanha && apoiarSemRecompensa">
                <i class="fa-solid fa-heart mr-1"></i> Contribuição de Livre Vontade
              </span>
            </div>

            <!-- Quick preset chips -->
            <div class="quick-amounts-bar mb-3">
              <button type="button" class="qa-chip" [class.active]="isValorAtivo(2000)"
                (click)="definirValorApoio(2000)">
                2.000 Kz
              </button>
              <button type="button" class="qa-chip" [class.active]="isValorAtivo(5000)"
                (click)="definirValorApoio(5000)">
                5.000 Kz
              </button>
              <button type="button" class="qa-chip" [class.active]="isValorAtivo(10000)"
                (click)="definirValorApoio(10000)">
                10.000 Kz
              </button>
              <button type="button" class="qa-chip" [class.active]="isValorAtivo(25000)"
                (click)="definirValorApoio(25000)">
                25.000 Kz
              </button>
              <button type="button" class="qa-chip" [class.active]="isValorAtivo(50000)"
                (click)="definirValorApoio(50000)">
                50.000 Kz
              </button>
            </div>

            <!-- Campo de texto / valor numérico livre -->
            <div class="input-with-currency">
              <span class="currency-tag">Kz</span>
              <p-inputnumber formControlName="valorApoio" placeholder="Insira o montante livre que deseja doar..." class="w-full"
                [min]="1"></p-inputnumber>
            </div>
            <small class="field-error" *ngIf="isInvalid('valorApoio')">
              <i class="fa-solid fa-triangle-exclamation"></i> O valor da contribuição é obrigatório e deve ser superior a zero.
            </small>
          </div>

          <!-- Método de Pagamento -->
          <div class="form-group mb-6">
            <label class="form-label">
              Método de Pagamento <span class="text-red-500">*</span>
            </label>

            <!-- Interactive Method Cards -->
            <div class="payment-methods-grid mb-3" *ngIf="metodoPaymentList?.length">
              <div class="pm-card" *ngFor="let item of metodoPaymentList" (click)="selectMetodo(item.id)"
                [class.active]="form.get('metodo')?.value === item.id">
                <div class="pm-radio">
                  <div class="pm-radio-inner"></div>
                </div>
                <div class="pm-icon">
                  <i class="fa-solid fa-mobile-screen" *ngIf="item.id === 2"></i>
                  <i class="fa-solid fa-receipt" *ngIf="item.id === 1"></i>
                  <i class="fa-solid fa-wallet" *ngIf="item.id !== 1 && item.id !== 2"></i>
                </div>
                <div class="pm-info">
                  <span class="pm-name">{{ item.label }}</span>
                  <span class="pm-desc" *ngIf="item.id === 2">Débito directo via app Multicaixa Express</span>
                  <span class="pm-desc" *ngIf="item.id === 1">Pagamento por entidade e referência nos ATMs</span>
                  <span class="pm-desc" *ngIf="item.id !== 1 && item.id !== 2">Débito do saldo da sua conta</span>
                </div>
              </div>
            </div>

            <small class="field-error" *ngIf="isInvalid('metodo')">
              <i class="fa-solid fa-triangle-exclamation"></i> O método de pagamento é obrigatório.
            </small>
          </div>

          <!-- Telefone se MCX -->
          <div class="form-group mb-6" *ngIf="metodo === 2">
            <label class="form-label" for="telefone">
              Número de Telefone Multicaixa Express <span class="text-red-500">*</span>
            </label>
            <div class="input-with-icon">
              <i class="fa-solid fa-mobile-screen-button input-icon"></i>
              <p-inputnumber placeholder="Ex: 923 000 000" formControlName="telefone" class="w-full"
                [useGrouping]="false"></p-inputnumber>
            </div>
            <span class="form-hint">
              <i class="fa-solid fa-info-circle"></i> Receberá uma notificação push para autorização no seu aplicativo
              Multicaixa Express.
            </span>
            <small class="field-error" *ngIf="isInvalid('telefone')">
              <i class="fa-solid fa-triangle-exclamation"></i> O número de telefone é obrigatório para pagamento por
              Multicaixa Express.
            </small>
          </div>

          <!-- Detalhe da comissão / Taxa de serviço -->
          <div class="fee-summary-box mb-6" *ngIf="!useSaldoUser && form.get('valorApoio')?.value">
            <div class="fsb-header">
              <i class="fa-solid fa-file-invoice-dollar"></i>
              <span>Resumo do Pagamento</span>
            </div>
            <div class="fsb-row">
              <span class="fsb-lbl">Valor do Apoio:</span>
              <span class="fsb-val">{{ form.get("valorApoio")?.value | money }} Kz</span>
            </div>
            <div class="fsb-row" *ngIf="taxaServico > 0">
              <span class="fsb-lbl">Taxa de serviço FundCube ({{ taxaServico }}%):</span>
              <span class="fsb-val fee">+ {{ ((form.get("valorApoio")?.value * taxaServico) / 100) | money }} Kz</span>
            </div>
            <div class="fsb-divider"></div>
            <div class="fsb-row total">
              <span class="fsb-lbl">Total a Pagar:</span>
              <span class="fsb-val total-val">{{ totalDoar | money }} Kz</span>
            </div>
          </div>

          <!-- Informações de Método -->
          <div class="method-info-card mb-6" *ngIf="metodo === 1">
            <div class="mic-icon"><i class="fa-solid fa-receipt"></i></div>
            <div class="mic-text">
              <h5>Pagamento por Referência Bancária</h5>
              <p>Ao confirmar, será gerada uma entidade e referência Multicaixa válida por 3 dias, pagável em qualquer
                ATM, Internet Banking ou Multicaixa Express.</p>
            </div>
          </div>

          <div class="method-info-card mb-6" *ngIf="metodo === 2">
            <div class="mic-icon"><i class="fa-solid fa-mobile-screen"></i></div>
            <div class="mic-text">
              <h5>Pagamento por Multicaixa Express</h5>
              <p>Uma notificação de débito será enviada ao seu aplicativo Multicaixa Express. Abra a app para confirmar
                com o seu PIN de segurança.</p>
            </div>
          </div>

          <!-- Botão Submeter Pagamento -->
          <button class="btn btn-primary btn-lg w-full submit-financing-btn" type="button" (click)="submitPayment()"
            [disabled]="btn_disabled || loading">
            <i class="fa-solid fa-spinner fa-spin" *ngIf="loading"></i>
            <i class="fa-solid fa-lock" *ngIf="!loading"></i>
            <span>{{ loading ? "A processar pagamento..." : "Confirmar e Financiar " + (totalDoar ? (totalDoar | money)
              + " Kz" : "") }}</span>
          </button>
        </form>

        <!-- CARD DE RESPOSTA / REFERÊNCIA GERADA -->
        <div *ngIf="showResposta" class="reference-generated-card mt-6">
          <div class="rgc-header">
            <div class="rgc-icon"><i class="fa-solid fa-circle-check"></i></div>
            <div>
              <h3>Referência Gerada com Sucesso!</h3>
              <p>Efectue o pagamento nos canais Multicaixa para validar a sua contribuição.</p>
            </div>
          </div>

          <div class="rgc-body">
            <div class="rgc-field">
              <span class="rgc-lbl">Entidade</span>
              <div class="rgc-val-row">
                <span class="rgc-val">{{ resposta?.entityAppyPay || "00000" }}</span>
                <button type="button" class="btn-copy" (click)="copyToClipboard(resposta?.entityAppyPay)"
                  title="Copiar Entidade">
                  <i class="fa-regular fa-copy"></i>
                </button>
              </div>
            </div>

            <div class="rgc-field">
              <span class="rgc-lbl">Referência</span>
              <div class="rgc-val-row">
                <span class="rgc-val ref">{{ resposta?.referenceNumberAppyPay || "000 000 000" }}</span>
                <button type="button" class="btn-copy" (click)="copyToClipboard(resposta?.referenceNumberAppyPay)"
                  title="Copiar Referência">
                  <i class="fa-regular fa-copy"></i>
                </button>
              </div>
            </div>

            <div class="rgc-field">
              <span class="rgc-lbl">Montante a Pagar</span>
              <span class="rgc-val price">{{ resposta?.valorApoio | money }} Kz</span>
            </div>
          </div>

          <div class="rgc-footer">
            <i class="fa-solid fa-shield-halved"></i>
            <span>Assim que liquidado, o montante será creditado e reflectido instantaneamente nesta campanha.</span>
          </div>
        </div>

      </div>
    </div>
  </main>
</div>